import {
    GET_TICKETS_SUCCESS,
    GET_TICKETS_FAIL,
    GET_TICKET_DETAIL_SUCCESS,
    GET_TICKET_DETAIL_FAIL,
    CREATE_SUPPORT_TICKET_SUCCESS,
    CREATE_SUPPORT_TICKET_FAIL,
    REPLY_SUPPORT_TICKET_SUCCESS,
    REPLY_SUPPORT_TICKET_FAIL,
} from "./actionTypes"

const INIT_STATE = {
    tickets: { data: [] },
    ticket: null,
    error: {},
    loading: false,
}

const Tickets = (state = INIT_STATE, action) => {
    switch (action.type) {
        case GET_TICKETS_SUCCESS:
            return {
                ...state,
                tickets: action.payload,
            }

        case GET_TICKETS_FAIL:
            return {
                ...state,
                error: action.payload,
            }

        case GET_TICKET_DETAIL_SUCCESS:
            return {
                ...state,
                ticket: action.payload,
            }

        case GET_TICKET_DETAIL_FAIL:
            return {
                ...state,
                error: action.payload,
            }

        case CREATE_SUPPORT_TICKET_SUCCESS:
            return {
                ...state,
                tickets: {
                    ...state.tickets,
                    data: [action.payload, ...(state.tickets.data || [])]
                },
            }

        case CREATE_SUPPORT_TICKET_FAIL:
            return {
                ...state,
                error: action.payload,
            }

        case REPLY_SUPPORT_TICKET_SUCCESS:
            return {
                ...state,
                ticket: {
                    ...state.ticket,
                    messages: [...(state.ticket?.messages || []), action.payload]
                }
            }

        case REPLY_SUPPORT_TICKET_FAIL:
            return {
                ...state,
                error: action.payload,
            }

        default:
            return state
    }
}

export default Tickets
